import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import {
  Edit,
  Delete,
} from '@mui/icons-material';
import { ProgramLevelDto } from '../../../api/types/dtos/program';

interface LevelCardProps {
  level: ProgramLevelDto;
  onEdit: (level: ProgramLevelDto) => void;
  onDelete: (levelId: string) => void;
  disabled?: boolean;
}

const LevelCard: React.FC<LevelCardProps> = ({
  level,
  onEdit,
  onDelete,
  disabled = false,
}) => {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const handleDelete = () => {
    if (level.id) {
      onDelete(level.id);
      setDeleteDialogOpen(false);
    }
  };

  return (
    <>
      <Card
        sx={{
          mb: 2,
          border: '1px solid',
          borderColor: 'divider',
          '&:hover': {
            boxShadow: 2,
          },
        }}
      >
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Box sx={{ flex: 1 }}>
              <Typography variant="h6" component="div" gutterBottom>
                {level.name}
              </Typography>
              {level.description && (
                <Typography variant="body2" color="text.secondary">
                  {level.description}
                </Typography>
              )}
            </Box>

            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Tooltip title="Editar">
                <IconButton
                  size="small"
                  onClick={() => onEdit(level)}
                  disabled={disabled}
                  color="primary"
                >
                  <Edit fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Eliminar">
                <IconButton
                  size="small"
                  onClick={() => setDeleteDialogOpen(true)}
                  disabled={disabled}
                  color="error"
                >
                  <Delete fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          </Box>
        </CardContent>
      </Card>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirmar Eliminación</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Está seguro que desea eliminar el nivel &quot;{level.name}&quot;? Esta acción no se puede deshacer.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancelar</Button>
          <Button onClick={handleDelete} color="error" variant="contained">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LevelCard;

